<template>
  <div class="ale-head">
    <div class="ale-head-l">
<!--      <span>{{ nowTime }}</span>-->
      <ul class="">
        <li style="margin-left: -10px" :class="showIndexTab === 0 ? 'on' : ''" @click="changeScreen(0)">重要指标</li>
        <li :class="showIndexTab === 1 ? 'on' : ''" @click="changeScreen(1)">现货均价</li>
        <li :class="showIndexTab === 2 ? 'on' : ''" @click="changeScreen(2)">价差指数</li>
        <li :class="showIndexTab === 3 ? 'on' : ''" @click="changeScreen(3)">涤纶去化</li>
      </ul>
    </div>
    <div class="ale-head-c">
      {{headline}}
      <span>{{headline}}</span>
    </div>
    <div class="ale-head-r" style="text-align: right">
      <ul class="">
        <li style="margin-right: -20px" :class="showIndexTab === 4 ? 'on' : ''" @click="changeScreen(4)">锦纶承压</li>
        <li :class="showIndexTab === 5 ? 'on' : ''" @click="changeScreen(5)">氨纶承压</li>
        <li :class="showIndexTab === 6 ? 'on' : ''" @click="changeScreen(6)">粘胶分化</li>
        <li :class="showIndexTab === 7 ? 'on' : ''" @click="changeScreen(7)">棉纱分化</li>
      </ul>
<!--      <i class="el-icon-s-custom head-icon" title="登录" style="margin-right: 16px;"></i>-->
      <i class="iconfont head-icon" :class="isFullscreen ? 'icon-tuichuquanping' : 'icon-quanping'" :title="isFullscreen ? '窗口模式' : '全屏'"  @click="handleToggleFullscreen" style="margin-right: 16px;"></i>
    </div>
  </div>
</template>

<script>
import {parseTime} from '../../../bll/utils'
import EventBus from '../../../bll/eventbus'
export default {
  name: 'aleHead',
  props: {
    loginToken: {},
    showIndex: {},
  },
  data () {
    return {
      nowTime: '',
      isFullscreen: false,
      headline: '阿拉尔化纤数字大屏',
      showIndexTab: 0,
      employeeScrollTimer: '',
    }
  },
  mounted () {
    if (this.loginToken) {
      this.startPlayback()
    }
    EventBus.$on('getStartPlayback', () => {
      this.startPlayback()
    })
    const that = this
    setInterval(function () {
      that.nowTime = parseTime(new Date(), '{y}年{m}月{d}日 星期{a} {h}:{i}:{s}')
    }, 1000)
    document.addEventListener('fullscreenchange', this.updateFullscreenState)
    document.addEventListener('webkitfullscreenchange', this.updateFullscreenState)
    document.addEventListener('mozfullscreenchange', this.updateFullscreenState)
    document.addEventListener('MSFullscreenChange', this.updateFullscreenState)
  },
  beforeDestroy () {
    // 组件销毁时移除监听，防止内存泄漏
    document.removeEventListener('fullscreenchange', this.updateFullscreenState)
    document.removeEventListener('webkitfullscreenchange', this.updateFullscreenState)
    document.removeEventListener('mozfullscreenchange', this.updateFullscreenState)
    document.removeEventListener('MSFullscreenChange', this.updateFullscreenState)
    window.clearInterval(this.employeeScrollTimer)
    EventBus.$off('getStartPlayback')
  },
  methods: {
    changeScreen (tab) {
      if (this.loginToken) {
        this.showIndexTab = tab
        this.$emit('updateShowIndex', tab)
      } else {
        this.$message({
          message: '请先登录！',
          type: 'warning'
        })
      }
    },
    updateFullscreenState () {
      this.isFullscreen = !!(document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement)
    },
    handleToggleFullscreen () {
      const element = document.documentElement // 让 html 标签全屏（即整个页面）
      if (!this.isFullscreen) {
        // 进入全屏
        const requestMethod = element.requestFullscreen ||
          element.webkitRequestFullscreen ||
          element.mozRequestFullScreen ||
          element.msRequestFullscreen

        if (requestMethod) {
          requestMethod.call(element)
        }
      } else {
        // 退出全屏
        const exitMethod = document.exitFullscreen ||
          document.webkitExitFullscreen ||
          document.mozCancelFullScreen ||
          document.msExitFullscreen

        if (exitMethod) {
          exitMethod.call(document)
        }
      }
    },
    startPlayback () {
      this.employeeScrollTimer = window.setInterval(() => {
        this.changeScreen((this.showIndexTab + 1) % 8)
      }, 1000 * 60 * 0.5)
    }
  }
}
</script>

<style scoped>
.ale-head{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 103px;
  background: url("../../../assets/ale/head-bg.png") no-repeat center/100%, url("../../../assets/ale/head-d-bg.png") no-repeat center -30px/100%;
  z-index: 998;
  display: flex;
  justify-content: space-between;
  color: #fff;
}
.ale-head-l,.ale-head-r{
  flex: 1;
  font-size: 16px;
  padding: 12px 16px;
}
.ale-head-c{
  width: 595px;
  margin-top: 9px;
  font-family: 微软雅黑;
  font-size: 62px;
  height: 60px;
  position: relative;
  letter-spacing: 2px;
  color: #fff;
  text-shadow: 0 6px 10px #000;
}

.ale-head-c span{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom,#ffffff 68%,rgba(5,65,165,.6),rgba(0,0,0,.9));
  -webkit-background-clip: text;
  color: transparent;
  text-shadow: none;
}
.head-icon{
  font-size: 22px;
  cursor: pointer;
  vertical-align: middle;
  margin-right: 14px;
}
.ale-head ul{
  margin-top: -12px;
  display: flex;
  flex-wrap:nowrap;
}

.ale-head li{
  width: 146px;
  height: 72px;
  background: url("../../../assets/ale/dg_bg.fw.png") no-repeat;
  background-position: 0 0;
  font-size: 21px;
  font-family: "fzskjt";
  line-height: 72px;
  color: #006DF8;
  font-style: italic;
  text-shadow: 3px 2px 7px rgba(0,0,0,0.65);
  cursor: pointer;
}

.ale-head li:hover{
  color: #B7D8FF;
  font-size: 22px;
}

.ale-head-l li{
  padding-left: 26px;
  margin-left: -28px;
}

.ale-head-l li.on{
  background-position: 0 -72px;
  color: #B7D8FF;
  font-size: 24px;
}

.ale-head-r li{
  padding-right: 40px;
  margin-right: -42px;
  background-position: 0 -144px;
  text-align: right;
}

.ale-head-r li.on{
  background-position: 0 -216px;
  color: #B7D8FF;
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/views/ale/modules/aleHead.vue